// src/services/MonitoringService.js
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { getSessionId } from '../utils/sessionId';

const IS_PROD = process.env.NODE_ENV === 'production';
const DEDUP_WINDOW_MS = 30_000;
const recentEvents = new Map();

// Cache du hash userId pour éviter de recalculer à chaque appel
const hashCache = new Map();

async function hashUserId(userId) {
  if (!userId) return null;
  if (hashCache.has(userId)) return hashCache.get(userId);

  const data = new TextEncoder().encode(userId + 'drumigo-monitoring');
  const buf = await crypto.subtle.digest('SHA-256', data);
  const hash = Array.from(new Uint8Array(buf))
    .slice(0, 8)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');

  hashCache.set(userId, hash);
  return hash;
}

function isDuplicate(dedupKey) {
  const last = recentEvents.get(dedupKey);
  if (last && Date.now() - last < DEDUP_WINDOW_MS) return true;
  recentEvents.set(dedupKey, Date.now());
  return false;
}

async function log(level, type, params = {}, userId = null) {
  if (!IS_PROD) return;

  const dedupKey = `${level}:${type}:${params.exerciseId || params.tierId || params.levelId || ''}`;
  if (isDuplicate(dedupKey)) return;

  try {
    const userHash = await hashUserId(userId);
    await addDoc(collection(db, 'appLogs'), {
      level,
      type,
      ...params,
      userHash,
      sessionId: getSessionId(),
      timestamp: Timestamp.now(),
      ua: navigator.userAgent.substring(0, 120),
    });
  } catch {
    // Fail silently — le monitoring ne doit jamais casser l'app
  }
}

const MonitoringService = {
  error: (type, params = {}, userId = null) => log('error', type, params, userId),
  warning: (type, params = {}, userId = null) => log('warning', type, params, userId),
  info: (type, params = {}, userId = null) => log('info', type, params, userId),
};

export default MonitoringService;
